<template>
  <div
    class="max-w-screen-xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
  >
    <div
      v-for="(card, index) in cards"
      :key="index"
      class="dark:[box-shadow:0_0_.15em_.1em_rgba(98,69,116,0.5)] dark:hover:[box-shadow:0_0_.15em_.1em_rgba(98,69,116,0.8)] dark:bg-transparent p-6 rounded-xl hover:[box-shadow:0_.0625rem_.75rem_0_rgba(38,57,82,.2)] [box-shadow:0_.3em_.3em_-.3em_hsla(0,0%,4%,.1),_0_0_0_.1rem_hsla(0,0%,4%,.08)] transition-all duration-500"
    >
      <NuxtImg
        :src="card.img"
        width="64"
        height="64"
        :alt="card.alt ?? 'List Card Image'"
        class="mb-4"
        loading="lazy"
        format="webp"
      />
      <h3 class="font-bold text-lg mb-2">
        {{ card.title }}
      </h3>
      <p class="text-sm !leading-[1.8] tracking-[0.5px] font-medium">
        {{ card.text }}
      </p>
      <ul class="flex flex-col w-full items-start gap-y-3 mt-6">
        <li
          v-for="(item, i) in card.feature.split(',')"
          :key="i"
          class="bg-[url('/images/right-single.webp')] font-semibold bg-no-repeat bg-[position:0_8px] m-0 pl-[22px] text-sm tracking-[0.5px] leading-[1.7]"
        >
          {{ item }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  cards: unknown[];
}>();
</script>
